<template lang="pug">
  .content
    .part-2
      .title 单车/助力车获得能量规则
      .small-title 获得能量的条件
      .conditions
        .condition-item.flex-mid
          img.condition-icon(
            src="https://m.hellobike.com/resource/AppPlatformH5/ant-forest/_6nadD7-zkMtcUPRQZwVr.png"
          )
          .condition-content 2020.11.5之后用
          .condition-content 支付宝购卡或付车费
        .condition-item.flex-mid
          img.condition-icon(
            src="https://m.hellobike.com/resource/AppPlatformH5/ant-forest/Mq-XZVvrrFV3OC2f2sKDf.png"
          )
          .condition-content 骑行单车或
          .condition-content 助力车
        .condition-item.flex-mid
          img.condition-icon(
            src="https://m.hellobike.com/resource/AppPlatformH5/ant-forest/VRDrwJj1AGbVxkGHrWitS.png"
          )
          .condition-content 单次骑行
          .condition-content 3分钟以上
      .small-title 能获得多少能量
      .rule
        .rule-title 单次骑行最高获得能量
        .rule-content
          span 1.8g/分钟 x 单次骑行上限30分钟 = 54g
      .rule
        .rule-title 单日骑行最高获得能量
        .rule-content
          span 1.8g/分钟 x 单日累计上限88分钟 = 159g
          span.gray (向上取整)
    .part-2
      .title 电动车获得能量规则
      .small-title 获得能量的条件
      .conditions
        .condition-item.flex-mid
          img.condition-icon(
            src="https://m.hellobike.com/resource/AppPlatformH5/ant-forest/mU79N6iRYxU0OOr8xMCPe.png"
          )
          .condition-content 日累计骑行
          .condition-content 4公里以上
      .small-title 能获得多少能量
      .rule
        .rule-title 单日骑行最高获得能量
        .rule-content
          span 3公里起步，每超过1公里得16g能量，每日上限320g。
</template>

<script>


export default {

};
</script>

<style lang="less" scoped>
.content {
  .part-2 {
    width: 3.51rem;
    background: #fff;
    border-radius: 0.08rem;
    padding-top: 0.14rem;
    padding-bottom: 0.2rem;
    box-shadow: 0 0.02rem 0.08rem 0 rgba(0, 0, 0, 0.04);

    &:nth-child(2) {
      margin-top: 0.11rem;
    }

    .small-title {
      margin-left: 0.23rem;
      position: relative;
      font-size: 0.14rem;
      font-weight: 600;
      color: #242729;
      line-height: 0.2rem;

      &::before {
        content: '';
        display: block;
        width: 0.02rem;
        height: 0.14rem;
        background: #1993ff;
        border-radius: 0.01rem;
        position: absolute;
        top: 48%;
        left: -0.06rem;
        transform: translateY(-50%);
      }
    }

    .title {
      font-size: 0.16rem;
      font-weight: 600;
      color: #242729;
      text-align: center;
      margin-bottom: 0.24rem;
    }

    .conditions {
      display: flex;
      justify-content: space-between;
      padding-left: 0.23rem;
      padding-right: 0.34rem;
      margin-top: 0.16rem;
      margin-bottom: 0.32rem;

      .condition-item {
        flex-direction: column;

        &:nth-of-type(2) {
          position: relative;
          left: -0.1rem;
        }

        .condition-icon {
          width: 0.4rem;
          height: 0.4rem;
          margin-bottom: 0.08rem;
        }

        .condition-content {
          font-size: 0.12rem;
          line-height: 0.17rem;
          font-weight: 500;
          color: #5a6066;
        }
      }
    }

    .rule {
      margin-left: 0.21rem;
      margin-top: 0.12rem;
      font-size: 0.12rem;
      line-height: 0.17rem;

      .rule-title {
        font-weight: 500;
        color: #242729;
      }

      .rule-content {
        color: rgba(135, 144, 153, 1);
      }
    }
  }
}
</style>
